// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App'
import {
  /* eslint-disable no-unused-vars */
  Style,
  Cell,
  Button,
  RadioGroup,
  CheckboxGroup,
  Input,
  Lazyload,
  Toast,
  Dialog,
  Locale,
  Theme
} from '@didi/rich-ui'
import CouponUI from '@didi/soda-c-coupon'
import router from './router'
import store from './store'
import '@/common/js/rem'
import axios from 'axios'
import didiaxios from '@didi/dajax/dist/dajax'
// import mockBridge from '../mock/bridge' // 在执行 rgettext-extract 之前，该文件不存在
import { init } from './init'
// import vConsole from 'vconsole'
import initGlobalFilters from './filter'
import '@didi/soda-jsbridge'
import DDBridge from './plugin/DDBridge'
import { getLanguageLong } from '@didi/gettext'
import i18n, { i18nInterceptors } from './common/js/i18n'
import vueI18n from './i18n/locale'
// 性能分析工具库
import PerformanceTool from '@didi/soda-fe-performance-tool'
// 需要被记录时间的请求列表
import NEED_RECORD_API_LIST from '@/common/js/homepage-request-url'

PerformanceTool.init({
  NEED_RECORD_API_LIST
})

const currentLang = getLanguageLong()
DDBridge.registerDefaultBridge()

Vue.use(DDBridge)
Vue.use(CouponUI)
Vue.use(i18n.plugin)
axios.interceptors.request.use(i18nInterceptors, error => Promise.reject(error))
didiaxios.interceptors.request.use(i18nInterceptors, error => Promise.reject(error))
Vue.prototype.$http = axios
Vue.prototype.$didihttp = didiaxios

Vue.use(Cell)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Locale)
Vue.use(Input)
Vue.use(Theme)
const { country } = store.state
// 巴西使用99主题
if (country === 'BR') {
  Theme.use('99')
// 墨西哥使用didi主题
} else if (country === 'MX') {
  Theme.use('didi')
} else {
  // 使用didi主题兜底
  Theme.use('didi')
}

Vue.use(Lazyload, {
  preLoad: 1,
  attempt: 3, // 尝试计数
  filter: {
    progressive(listener, options) {
      const size = listener.el.getAttribute('crop-size')
      // SODA 图床暂只支持soda-public的服务
      const isSodaPublic = /soda-public/
      if (size && isSodaPublic.test(listener.src)) {
        listener.src = `${listener.src}!${size}_m`
      }
    }
  }
})
// TODO: Set up international language according to URL
// If rich-ui does not have a built-in language pack, it needs to mention PR or introduce language packets separately.
Locale.use(currentLang, require(`@didi/rich-ui/lib/locale/lang/${currentLang}`))
CouponUI.locale.use(require(`@didi/soda-c-coupon/src/locale/lang/${currentLang}`).default)


initGlobalFilters()
/* eslint-disable no-new */
Vue.config.productionTip = false

// Registering Our Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-soda-act.js').then(registration => {
      console.log('SW registered: ', registration)
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError)
    })
  })
}


/* Date: 2019-05-24 Author: jiaqian
 * 异步获取语言设置，需要在回调中去实例化VueJed及Vue
 * 改动影响范围较大，暂时不上
*/
// function initVueCb (currentLang) {
//   Locale.use(currentLang, require(`@didi/rich-ui/lib/locale/lang/${currentLang}`))
//   initVueJed(currentLang)
//   new Vue({
//     el: '#app',
//     router,
//     store,
//     render: h => h(App)
//   })
// }
/* eslint-disable no-new */
init().then(() => {
  new Vue({
    el: '#app',
    i18n: vueI18n,
    router,
    store,
    render: h => h(App)
  })
})
